// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Wraps a route so it requires authentication.
// Optional `requiredType` ('customer' | 'provider') enforces user type.
// Unauthenticated users are redirected to /login.
// Unverified users (emailVerified === false) are redirected to /verify-email.
// Wrong-type users are redirected to their own dashboard.
const ProtectedRoute = ({ children, requiredType }) => {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  if (user.emailVerified === false) return <Navigate to="/verify-email" replace />;

  if (requiredType && user.type !== requiredType) {
    const fallback = user.type === 'customer' ? '/customer-dashboard' : '/provider-dashboard';
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default ProtectedRoute;
